import React from "react";
import Navbar from "components/generales/Navbar";
import FiltrosBalanceCuenta from "pages/balance/FiltrosBalanceCuenta";

import "../balance/Balance.css";
import enConstruccion from "../../components/generales/under_constructions.png";

//En construcción, hay que reestructurar componentes y funciones
const ListadoGastos = () => {
  return (
    <>
      <Navbar />
      <div className="lista-preview">
        <h2>Listado de Gastos</h2>

        <FiltrosBalanceCuenta />
        <img src={enConstruccion} alt="" />
      </div>
      ;
    </>
  );
};

export default ListadoGastos;
